import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProductLowStockAndOutofStock } from "../api/inventoryApi";
import { getOutOfStock, getLowStock, getExpiredList } from "../slices/productSlice";

const useStockData = () => {
  const dispatch = useDispatch();

  const outOfProducts = useSelector((state) => state.products.outOfList);
  const lowProducts = useSelector((state) => state.products.lowList);
  const products = useSelector((state) => state.products.list);
  const categoryData = useSelector((state) => state.products.categories);
  const expiredList = useSelector((state) => state.products.expiredList);

  useEffect(() => {
    const fetchStockData = async () => {
      try {
        const response = await getProductLowStockAndOutofStock();
        dispatch(getExpiredList(response.data.expiredProducts));
        dispatch(getLowStock(response.data.lowproducts));
        dispatch(getOutOfStock(response.data.outOfProducts));
      } catch (error) {
        console.error("Erreur lors de la récupération des stocks:", error);
        alert(error.response?.data?.message || "Erreur lors de la récupération des stocks.");
      }
    };

    fetchStockData();
  }, [dispatch]);

  return { outOfProducts, lowProducts, products, categoryData,expiredList };
};

export default useStockData;
